import React from 'react';
import { DSButton, DSIcon, DSInput } from '../design-system/primitives';
import './WebsiteDetailsEditor.css';

const MAX_ROWS = 8;

/**
 * Rows for the Details table on a series' event pages on the club website,
 * shown ahead of the Cost row the site adds itself. NEPL uses it for "Games"
 * and "Season". A row with the label "Cost" replaces the site's own Cost row.
 *
 * value: [{ label, value }, ...]. The server keeps rows with both filled in.
 */
export default function WebsiteDetailsEditor({ id, value = [], onChange }) {
  const rows = value;
  const setRow = (index, patch) => onChange(rows.map((row, i) => (i === index ? { ...row, ...patch } : row)));
  const removeRow = (index) => onChange(rows.filter((_, i) => i !== index));
  const addRow = () => onChange([...rows, { label: '', value: '' }]);

  return (
    <fieldset className="website-details" aria-describedby={`${id}-help`}>
      <legend className="website-details__legend">Website details</legend>
      <p className="website-details__help" id={`${id}-help`}>
        Rows for the Details box on each of this series' event pages, above the cost. For example, Games: Four head-to-head games, groups of 3 to 4. Saving updates the upcoming events already on the website.
      </p>
      {rows.map((row, index) => (
        // Rows have no identity of their own beyond their place in the list.
        // eslint-disable-next-line react/no-array-index-key
        <div className="website-details__row" key={index}>
          <DSInput
            label="Label"
            id={`${id}-label-${index}`}
            value={row.label}
            maxLength={40}
            placeholder="e.g., Season"
            onChange={(e) => setRow(index, { label: e.target.value })}
          />
          <DSInput
            label="Value"
            id={`${id}-value-${index}`}
            value={row.value}
            maxLength={300}
            placeholder="e.g., 8 weeks. Attend at least 5 to qualify"
            onChange={(e) => setRow(index, { value: e.target.value })}
          />
          <DSButton
            appearance="outline"
            tone="neutral"
            size="sm"
            iconOnly
            aria-label={`Remove ${row.label || 'this row'}`}
            leadingIcon={<DSIcon name="x" size="sm" />}
            onClick={() => removeRow(index)}
          />
        </div>
      ))}
      {rows.length < MAX_ROWS && (
        <DSButton appearance="outline" tone="neutral" size="sm" leadingIcon={<DSIcon name="plus" size="sm" />} onClick={addRow}>
          Add a row
        </DSButton>
      )}
    </fieldset>
  );
}

/** Series row value ([[label, value], ...]) to editor rows. */
export function toEditorRows(saved) {
  return Array.isArray(saved) ? saved.filter(Array.isArray).map(([label, value]) => ({ label: label || '', value: value || '' })) : [];
}
